import { defaultStaleTime } from "./consts";
import { useQuery } from "@tanstack/react-query";
import { downloadSchedule, downloadCourseSchedule } from "./utils";

export const useDownloadScheduleQuery = (gucSearchParamId) => {
  const query = useQuery({
    queryKey: ["downloadSchedule", gucSearchParamId],
    queryFn: () => downloadSchedule(gucSearchParamId),
    enabled: !!gucSearchParamId,
    staleTime: defaultStaleTime,
    retry: 0,
  });
  return query;
};

export const useDownloadCourseScheduleQuery = (courseCode) => {
  const query = useQuery({
    queryKey: ["downloadCourseSchedule", courseCode],
    queryFn: () => downloadCourseSchedule(courseCode),
    enabled: !!courseCode,
    staleTime: defaultStaleTime,
    retry: 0,
  });
  return query;
};
